import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { RG_TYPE, GetAllBones, GetAllJoints } from "@project-rouge/rg-core";
import { getRgObjectsOfType, getPivot } from "@project-rouge/rg-three";
import { Line, Plane } from "@react-three/drei";
import { memo, useMemo } from "react";
import { MathUtils } from "three";
import { getBuildingCenter } from "./index221.js";
import { SelectWingButton } from "./index224.js";
const WingSelector = memo(({ obj, onSelect, topOffset, readonly }) => {
  const buildings = useMemo(() => getRgObjectsOfType(obj, RG_TYPE.Building), [obj]);
  const bonesPerBuilding = useMemo(() => {
    return buildings.map((building) => ({
      building,
      bones: GetAllBones(building.data.anatomy)
    }));
  }, [buildings]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    buildings.map((b) => /* @__PURE__ */ jsx(BuildingCornerCores, { building: b, topOffset }, b.uuid)),
    bonesPerBuilding.flatMap((b) => b.bones.map((bone) => ({ building: b.building, bone }))).map(({ building, bone }) => /* @__PURE__ */ jsx(
      SelectWingButton,
      {
        building,
        bone,
        onClick: onSelect,
        topOffset,
        readonly
      },
      bone.id
    ))
  ] });
});
WingSelector.displayName = "WingEditorTool";
const BuildingCornerCores = ({ building, topOffset }) => {
  const cornerCores = useMemo(() => {
    const joints = GetAllJoints(building.data.anatomy);
    const cornerCores2 = [];
    for (const child of building.children) {
      if (child.type !== RG_TYPE.Core)
        continue;
      if (!child.data.isCorner)
        continue;
      const joint = joints.find((j) => j.id === child.data.jointID);
      const topLevel = Math.max(...joint.bones.map((b) => b.floors)) - 1;
      if (topLevel !== child.data.level)
        continue;
      const topBone = joint.bones.find((b) => b.floors === topLevel + 1);
      const y = getBuildingCenter(building, topBone)[1] * 2 + topOffset;
      const position = getPivot([0.5, 1, 0.5], child);
      position.y = y;
      const rotation = child.rot.map((v) => v * MathUtils.DEG2RAD);
      const size = [child.size[0], child.size[2]];
      cornerCores2.push({
        rotation,
        size,
        position: position.toArray()
      });
    }
    return cornerCores2;
  }, [building, topOffset]);
  return /* @__PURE__ */ jsx(Fragment, { children: cornerCores.map(({ position, rotation, size }, i) => /* @__PURE__ */ jsxs(
    "object3D",
    {
      position,
      rotation,
      children: [
        /* @__PURE__ */ jsx(
          Line,
          {
            points: [
              [-size[0] * 0.5, 0, -size[1] * 0.5],
              [size[0] * 0.5, 0, -size[1] * 0.5],
              [size[0] * 0.5, 0, size[1] * 0.5],
              [-size[0] * 0.5, 0, size[1] * 0.5],
              [-size[0] * 0.5, 0, -size[1] * 0.5]
            ],
            transparent: true,
            color: "#3B3B5F"
          }
        ),
        /* @__PURE__ */ jsx("object3D", { children: /* @__PURE__ */ jsx(
          Plane,
          {
            args: size,
            rotation: [-90 * MathUtils.DEG2RAD, 0, 0],
            "material-transparent": true,
            "material-opacity": 0.5
          }
        ) })
      ]
    },
    i
  )) });
};
export {
  WingSelector
};
//# sourceMappingURL=index174.js.map
